import { makeStyles } from '@rbx/ui';

const useResponseTableIteratorStyles = makeStyles()(() => ({
  code: {
    marginTop: 24,
    fontSize: '14px',
  },

  properties: {
    marginTop: 24,
  },

  schemaDescription: {
    marginBottom: 0,
  },

  description: {
    marginBottom: 24,
  },
}));

export default useResponseTableIteratorStyles;
